if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Clear any prior error
        this.handleErrorMessage();

        // --- 🔒 Jellycat limit (case-insensitive) ---
const tags = (this.dataset.productTags || '')
  .split(',')
  .map((t) => t.trim().toLowerCase())
  .filter(Boolean);

const isJellycat = tags.includes('jellycat');

if (isJellycat) {
  // Prevent rapid multi-clicks while checking
  if (this.submitButton.hasAttribute('data-jellycat-checking')) return;
  this.submitButton.setAttribute('data-jellycat-checking', 'true');

  // Variant being added
  const variantId = Number(this.form.querySelector('[name="id"]')?.value);

  try {
    const cart = await fetch('/cart.js').then((res) => res.json());

    // Block if THIS Jellycat variant is already in cart
    const alreadyInCart = (cart.items || []).some((item) => {
      return Number(item.variant_id) === variantId && Number(item.quantity) >= 1;
    });

    if (alreadyInCart) {
      this.handleErrorMessage('Jellycat items are limited to 1 per item.');
      if (!this.errorMessageWrapper) {
        alert('Jellycat items are limited to 1 per item.');
      }
      this.submitButton.removeAttribute('data-jellycat-checking');
      return;
    }
  } catch (e) {
    console.warn('Jellycat cart check failed; continuing add-to-cart.', e);
  }

  this.submitButton.removeAttribute('data-jellycat-checking');
}
// --- end Jellycat limit ---



        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.dataset.cartType != 'page') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.dataset.cartType == 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');

            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
